<div class="spinner-overlay" [class.cover-header]="coverHeader">
    <div class="loader-spinner">
        <mat-spinner diameter="75"></mat-spinner>
    </div>
</div>